import React, {Component} from 'react';
import WOW from 'wowjs';


//CSS
import './App.css';
import 'animate.css/animate.min.css';

//Components
import Footer from "./layout/Footer/Footer";

//Images
import logoRed from '../src/assets/img/myflogo-big.png';

class App extends Component {

    componentDidMount() {
        new WOW.WOW().init();

        // document.documentElement.style.overflowY = "hidden";

        // setTimeout(function () {
        //     document.getElementById("splash").className = "desaparece";
        //     setTimeout(function () {
        //         document.getElementById("splash").style.display = "none";
        //         document.documentElement.style.overflowY = "visible";
        //     }, 2000);
        // }, 3000);
    }

    render() {
        return (
            <div className="App">
                {/*<div id="splash" className="splash">*/}
                {/*    <img src={logoRed} alt="myf"/>*/}
                {/*</div>*/}
                {this.props.children}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js